"use strict";
import { addEvent } from "../addEvent/addEvent";
import { isMobile } from "../isMobile/isMobile";
import Scrollbar, { ScrollbarPlugin } from "smooth-scrollbar";

export const mainMenuClass = class {
  menuContainer = false;
  menuButton = false;
  menuList = false;
  nav = false;
  videoBgSrc = false;
  video = false;
  scrollbar = false;

  bodyMenuClassName = "full-page-main-menu";
  bodyMenuShowClassName = "main-menu-show";
  menuButtonClassName = "main-menu-button";
  menuContainerClassName = "full-site-menu-container";
  menuContainerScrollContainerClassName = "full-site-menu";

  menuIsShow = false;

  constructor() {
    let nav = document.getElementsByClassName("page-header__menu")[0];
    this.nav = nav;
    this.menuList = nav.querySelector("ul").cloneNode(true);
    if (nav.hasAttribute("data-videosrc"))
      this.videoBgSrc = nav.getAttribute("data-videosrc");

    this._init();

    return this;
  }

  _init = () => {
    const { bodyMenuClassName } = this;
    document.body.classList.add(bodyMenuClassName);

    this._createShowMobileMenuButton();
    this._cereateMenuContainer();
  };

  _cereateMenuContainer = () => {
    const {
      menuList,
      menuContainerClassName,
      menuContainerScrollContainerClassName,
    } = this;

    if (this.menuContainer) return;

    let menuContainer = document.createElement("div");
    menuContainer.classList.add(menuContainerClassName);

    let menuScrollContainer = document.createElement("div");
    menuScrollContainer.classList.add(menuContainerScrollContainerClassName);

    menuScrollContainer.appendChild(menuList);
    menuContainer.appendChild(menuScrollContainer);

    if (false && !isMobile() && !document.body.classList.contains("macos"))
      this._smoothScrollbarInit(menuScrollContainer);

    this.menuContainer = menuContainer;
    this.nav.before(this.menuContainer);
    // document.body.appendChild(this.menuContainer);

    //this._videoInit();
  };

  _createShowMobileMenuButton = () => {
    let menuButton = document.createElement("button");
    menuButton.setAttribute("class", this.menuButtonClassName);
    menuButton.classList.add("mouse-hover");
    menuButton.setAttribute("aria-label", "menu");
    menuButton.setAttribute("data-dotclass", "over-element");

    let span = document.createElement("span");
    menuButton.appendChild(span);
    span = document.createElement("span");
    menuButton.appendChild(span);
    span = document.createElement("span");
    menuButton.appendChild(span);
    span = document.createElement("span");
    menuButton.appendChild(span);
    span = document.createElement("span");
    menuButton.appendChild(span);
    span = document.createElement("span");
    menuButton.appendChild(span);

    this.menuButton = menuButton;

    this.nav.before(this.menuButton);

    this._showHideEvent();
  };

  _showHideEvent = () => {
    const { menuButton, bodyMenuShowClassName } = this;

    addEvent(menuButton, "click", (e) => {
      e.preventDefault();

      this.menuIsShow = !this.menuIsShow;
      if (false && window.smoothScroll)
        window.smoothScroll.updatePluginOptions("modal", {
          open: this.menuIsShow,
        });

      document.body.classList.toggle(bodyMenuShowClassName);
      // //if (this.video) this.video.play();
      return false;
    });

    addEvent(document, "keyup", (e) => {
      if (e.keyCode == 27 && this.menuIsShow) {
        document.body.classList.remove(bodyMenuShowClassName);
        this.menuIsShow = false;
        // setTimeout(() => {
        //   if (this.video) this.video.pause();
        // }, 750);
      }
    });
  };

  _videoInit = () => {
    const { videoBgSrc, menuContainer } = this;

    if (!videoBgSrc) return;

    let div = document.createElement("div");
    div.setAttribute("class", "menu-video-background");

    let video = document.createElement("video");
    video.classList.add("video-bg__video");
    video.loop = true;
    video.muted = true;
    video.autoplay = false;

    if (video.canPlayType("video/mp4").length > 0) {
      video.src = videoBgSrc;
    } else {
      return;
    }

    this.video = video;
    div.appendChild(this.video);
    this.menuContainer
      .getElementsByClassName("full-site-menu")[0]
      .appendChild(div);
  };

  _smoothScrollbarInit = (elm) => {
    elm.classList.add("page-smooth-scroll");

    this.scrollbar = Scrollbar.init(elm, {});
  };
};
